module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-id-ID.f948e661.jpg";